import React from "react"
import ReactDOM from "react-dom"
import ImageHero from "./image-hero"

export default class ImageHeroModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ImageHero {...this.modelJson} />, self.elem)
  }
}
